import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { CouchbaseCopySource } from 'app/model/pipeline/copysource/couchbase.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CouchbaseCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class CouchbaseCopySourceAdapter extends CopySourceAdapter<CouchbaseCopySource, Model.CouchbaseSource> {
    protected override async _toResource(copySource: CouchbaseCopySource): Promise<Model.CouchbaseSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(CouchbaseCopySource).name);
    }

    protected override async _toModel(
        resource: Model.CouchbaseSource,
        copyActivity: CopyActivity
    ): Promise<CouchbaseCopySource> {
        return this._toTabularModel(resource, copyActivity, CouchbaseCopySource.MODEL);
    }
}
